import {IsBrowser} from "./isBrowser";

export function getCurrentPath(){
    return IsBrowser()
        ? window.location.pathname
        : null;
}
